export default __webpack_public_path__ + "static/media/churn_assistance_video_walkthroughs.7fd271a1.gif";